import React from 'react'
import ModalBody from '../modalbody';
import MasterValues from '../mastervalue';
import ButtonLoader from '../btnloader';

const is_store = (process.env.REACT_APP_NAME === 'store');

const CallUsmodal = ({call}) => {
    return (
        <ModalBody heading={''}>
            <div className="p-25">
                <div className="flex-center">
                    <h2 className="f-600 text-center header-underline">Welcome to Ouja!</h2>
                </div>
                <div className="m-t-20">
                    <p className="text-center">{call ? 'Make your booking by calling us directly.' : 'Make your booking by pinging us directly.'}</p>
                    <p className="text-center">{call ? 'We shall be excited to on-board the consignment (OR) yourself at best service.' : 'We shall be excited to on-board the consignment (OR) yourself at best service.' }</p>
                </div>
                <div className="flex-center m-t-20">
                    <MasterValues Component={CallBtn} compProps={{call}} id={is_store ? 8 : 6} Loader={ButtonLoader}/>
                </div>
            </div>
        </ModalBody>
    )
}

const CallBtn = ({value, call=false}) => (
    <a href={call ? `tel:${value}` : `https://wa.me/${value}?text=Book%20Order`} className="btn btn-ouja btn-pad">
        {call ? <i className="fas fa-phone"></i> : <i className="fab fa-whatsapp"></i>}
        <span className="m-l-10">
            {value}
        </span>
    </a>
)

export default CallUsmodal
